"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Buttons_1 = __importDefault(require("./styledComponents/Buttons"));

var CoveringButton_1 = __importDefault(require("./styledComponents/CoveringButton"));

var PickerOverlay_1 = __importDefault(require("./styledComponents/PickerOverlay"));

var RefreshButton_1 = __importDefault(require("./styledComponents/RefreshButton"));

var SelectedImage_1 = __importDefault(require("./styledComponents/SelectedImage"));

var Thumbnail_1 = __importDefault(require("./styledComponents/Thumbnail"));

var ThumbnailImage_1 = __importDefault(require("./styledComponents/ThumbnailImage"));

var Thumbnails_1 = __importDefault(require("./styledComponents/Thumbnails"));

var ToggleButton_1 = __importDefault(require("./styledComponents/ToggleButton"));

var ImagePicker_meta_1 = require("./ImagePicker.meta");

var mobx_1 = require("mobx");

var Icon_1 = require("../Icon/Icon");

var ImagePicker = function (_super) {
  __extends(ImagePicker, _super);

  function ImagePicker(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = ImagePicker_meta_1.IMAGE_PICKER_CATEGORY_KEY;
    _this.componentKey = ImagePicker_meta_1.IMAGE_PICKER_COMPONENT_KEY;
    _this.showPickerOverlay = false;

    _this.initializeSelected = function () {
      var _a = _this.props.images,
          images = _a === void 0 ? [] : _a;
      var selected = _this.props.selected;

      if (!selected && images.length > 0) {
        selected = images[0];
      }

      _this.selected = selected;
    };

    _this.componentDidUpdate = function (newProps) {
      if (!_this.selected && newProps.selected) {
        _this.selected = newProps.selected;
      }
    };

    _this.handleSelect = function (image) {
      var onSelect = _this.props.onSelect;
      _this.selected = image;

      _this.togglePickerOverlay(false);

      if (onSelect) {
        onSelect(image);
      }
    };

    _this.handleToggleClick = function (event) {
      event.stopPropagation();

      _this.togglePickerOverlay();
    };

    _this.handleRefreshClick = function (event) {
      var onRefresh = _this.props.onRefresh;

      if (onRefresh) {
        onRefresh();
      }
    };

    _this.togglePickerOverlay = function (mustShow) {
      _this.showPickerOverlay = typeof mustShow === 'boolean' ? mustShow : !_this.showPickerOverlay;
    };

    _this.initializeSelected();

    return _this;
  }

  ImagePicker.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        _b = _a.images,
        images = _b === void 0 ? [] : _b;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, !this.showPickerOverlay && react_1.default.createElement(CoveringButton_1.default, {
      onClick: this.handleToggleClick
    }, react_1.default.createElement(SelectedImage_1.default, {
      src: this.selected && this.selected.src
    }), react_1.default.createElement(Buttons_1.default, null, react_1.default.createElement(ToggleButton_1.default, null, react_1.default.createElement(Icon_1.Icon, {
      asset: 'base.imagePicker.toggleDown'
    })))), this.showPickerOverlay && react_1.default.createElement(PickerOverlay_1.default, null, react_1.default.createElement(Thumbnails_1.default, null, images.map(function (image) {
      return react_1.default.createElement(Thumbnail_1.default, {
        key: image.id,
        onClick: function onClick() {
          return _this.handleSelect(image);
        }
      }, react_1.default.createElement(ThumbnailImage_1.default, {
        src: image.src
      }));
    })), react_1.default.createElement(Buttons_1.default, null, react_1.default.createElement(ToggleButton_1.default, {
      onClick: this.handleToggleClick
    }, react_1.default.createElement(Icon_1.Icon, {
      asset: 'base.imagePicker.toggleUp'
    })), react_1.default.createElement(RefreshButton_1.default, {
      onClick: this.handleRefreshClick
    }, react_1.default.createElement(Icon_1.Icon, {
      asset: 'base.imagePicker.refresh'
    })))));
  };

  __decorate([mobx_1.observable], ImagePicker.prototype, "showPickerOverlay", void 0);

  __decorate([mobx_1.observable], ImagePicker.prototype, "selected", void 0);

  ImagePicker = __decorate([mobx_react_1.observer], ImagePicker);
  return ImagePicker;
}(shared_1.ComponentBase);

exports.ImagePicker = ImagePicker;
exports.default = shared_1.InjectedStyledComponent(ImagePicker, ImagePicker_meta_1.IMAGE_PICKER_CATEGORY_KEY, ImagePicker_meta_1.IMAGE_PICKER_COMPONENT_KEY);